// ToDo: when we"ve revised all the text instances & styles, the revised variant will turn insto the baseStyle
var baseStyle = {
  fontFamily: "sans"
};
var variants = {
  revised: {
    // elements with the "revised" variant won"t need to be migrated to the new theme
    // ToDo: evaluate whether we need to reset these styles. at this point they override theme defaults, but that may go away once migration is finished
    lineHeight: "base",
    letterSpacing: "wide",
    fontWeight: "normal",
    color: "text"
  }
};
var sizes = {
  inherit: {
    fontSize: "inherit" //avoid overriding size

  },
  lg: {
    fontSize: "lg",
    fontWeight: "semibold"
  },
  md: {
    fontSize: "md"
  },
  sm: {
    fontSize: "sm"
  }
}; // preserve whatever style it"s set by means outside of BouqsUI.
// ToDo: we want to be able to remove this baseStyle and replace it with the "revised" variant. This is a placeholder while we finish the theme migration

var defaultProps = {
  size: "inherit"
};
export default {
  baseStyle,
  variants,
  sizes,
  defaultProps
};
//# sourceMappingURL=text.js.map